export default "data:image/svg+xml,soviet_union.svg"